import axios from "axios";
const host = window.location.host;
let instance;
switch (host) {
    case "login.advantechwifi.com":
    case "advantechny.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/advantechny",
        });
        break;
    }
    // case "anywair.wifikey.io": {
    //     instance = axios.create({
    //         baseURL: "https://api.wifikey.io/anywair",
    //     });
    //     break;
    // }
    case "arborcompany.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/arborcompany",
        });
        break;
    }
    case "baiconnect.wifikey.io":
    case "rover.baiconnect.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/baiconnect",
        });
        break;
    }
    case "blueport.wifikey.io":
    case "wifi.blueportwireless.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/blueport",
        });
        break;
    }
    case "comcast.wifikey.io": { 
        instance = axios.create({
            baseURL: "https://api.wifikey.io/comcast",
        });
        break;
    }
    case "dishfiber.wifikey.io":
    case "www.mydishfiber.com":
    case "connect.gomereo.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/dishfiber",
        });
        break;
    }
    case "elauwit.wifikey.io":
    case "wifi.elauwit.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/elauwit",
        });
        break;
    }
    // case "engenius.wifikey.io": { 
    //     instance = axios.create({
    //         baseURL: "https://api.wifikey.io/engenius",
    //     });
    //     break;
    // }
    case "fairwayisp.wifikey.io":
    case "wifi.fairwayisp.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/fairwayisp",
        });
        break;
    }
    case "wifi.getgrooven.com":
    case "getgrooven.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/getgrooven",
        });
        break;
    }
    case "wifi.gigstreem.com":
    case "gigstreem.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/gigstreem",
        });
        break;
    }
    case "gigstreem2.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/gigstreem2",
        });
        break;
    }
    case "gozone.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/gozone",
        });
        break;
    }
    case "gsdsolutions.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/gsdsolutions",
        });
        break;
    }
    case "wifi.hyperleapnetwork.com":
    case "hyperleap.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/hyperleap",
        });
        break;
    }
    case "wifi.ibt.us":
    case "ibtgroup.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/ibtgroup",
        });
        break;
    }
    case "interactsolutions.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/interactsolutions",
        });
        break;
     }
    case "latigo.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/latigo",
        });
        break;
    }
    case "wifi.leowifi.net":
    case "leo.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/leo",
        });
        break;
    }
    case "lightwave.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/lightwave",
        });
        break;
    }
    case "connect.kuducom.com":
    case "kuducom.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/kuducom",
        });
        break;
    }
    case "mera.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/mera",
        });
        break;
    }
    case "portal.gomereo.com":
    case "mereonetworks.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/mereonetworks",
        });
        break;
    }
    case "proptex.wifikey.io":
    case "connect.futurelabs.com.au": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/proptex",
        });
        break;
    }
    case "demo.roamingiq.com":
    case "roamingiq-demo.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/roamingiq-demo",
        });
        break;
    }
    case "demo1.roamingiq.com":
    case "roamingiq-demo1.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/roamingiq-demo1",
        });
        break;
    }
    case "demo2.roamingiq.com":
    case "roamingiq-demo2.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/roamingiq-demo2",
        });
        break;
    }
    case "demo3.roamingiq.com":
    case "roamingiq-demo3.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/roamingiq-demo3",
        });
        break;
    }
    case "sbasite.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/sbasite",
        });
        break;
    }
    case "slopeautomation2.wifikey.io":
    case "www.slopewifi.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/slopeautomation2",
        });
        break;
    }
    case "smartrent.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/smartrent",
        });
        break;
    }
    case "souderproperties.wifikey.io": 
    case "wifi.souderproperties.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/souderproperties",
        });
        break;
    }
    case "spotonnetworks.wifikey.io":
    case "wifi.spotonnetworks.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/spotonnetworks",
        });
        break;
    }
    case "tektg.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/tektg",
        });
        break;
    }
    case "tplink.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/tplink",
        });
        break;
    }
    case "vault.worldvue.com":
    case "wcitv.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/wcitv",
        });
        break;
    }
    case "whitesky.wifikey.io":
    case "login.whitesky.us": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/whitesky",
        });
        break;
    }
    case "whitesky-test.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/whitesky-test",
        });
        break;
    }
    case "wibuz.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/wibuz",
        });
        break;
    }
    case "xperity.wifikey.link": {
        instance = axios.create({
            baseURL: "https://apixperity.us-east-1.wifikey.link/xperity",
        });
        break;
    }
    case "roamingiq.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/v1",
        });
        break;
    }
    case "localhost:3000": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/v1qa",
        });
        break;
    }
    case "localhost:3001":
        case "localhost:3002": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/roamingiq-demo",
        });
        break;
    }
    default: {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/preview",
        });
        break;
    }
}
sessionStorage.setItem("host", host);
// baseURL: 'https://api.roamingiqtest.com/v1qa'
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const originalRequest = error.config;
        //console.log(originalRequest);
        const refreshToken = sessionStorage.getItem("AccessToken");
        if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest && refreshToken) {
            originalRequest._retry = true;
            //console.log("Refreshing");
            instance
                .post("/subscriberconsole/refreshAccessToken", {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    RefreshToken: sessionStorage.getItem("RefreshToken"),
                })
                //.then((res) => res.json())
                .then((tokenRefreshResponse) => {
                    //console.log("Refreshing");
                    //console.log(tokenRefreshResponse);
                    sessionStorage.setItem("AccessToken", tokenRefreshResponse.data.AuthenticationResult.AuthenticationResult.AccessToken);
                    originalRequest.headers["Authorization"] = tokenRefreshResponse.data.AuthenticationResult.AuthenticationResult.AccessToken;
                    return Promise.resolve();
                });
        }
        return Promise.reject(error);
    }
);
export default instance;
